export default __webpack_public_path__ + "static/media/Acton-01.1e8ac6f1.jpg";